import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { CardGridSkeleton } from './CardGridSkeleton';
import { PageWrapper } from '@/components/layout';

/**
 * Skeleton for the Committees page.
 * Layout similar to Legislators page.
 */
export function CommitteesPageSkeleton() {
  return (
    <PageWrapper header={<PageHeaderSkeleton variant="gradient" showDescription={true} />}>
      <div className="space-y-6 mb-12">
        {/* Year Selector Card */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded" />
              <Skeleton className="h-5 w-32" />
            </div>
            <Skeleton className="h-9 w-[180px]" />
          </div>
        </div>

        {/* Filters Section */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-4 space-y-4">
          <Skeleton className="h-10 w-full sm:w-80" />
          <div className="flex flex-wrap gap-2">
            <Skeleton className="h-10 w-28" />
            <Skeleton className="h-10 w-28" />
          </div>
        </div>

        {/* Results */}
        <div className="space-y-4">
          <Skeleton className="h-4 w-36" />
          <CardGridSkeleton count={6} />
        </div>
      </div>
    </PageWrapper>
  );
}
